// Centralizes Stripe pause_collection semantics so the 14-day cancel-flow
// extension (internally a pause, presented as an "extension" and kept in the
// draw) is never confused with a legacy 1-month manual pause.

export interface PausableSubscription {
  pause_collection?: unknown | null;
}

interface ExtendableUser {
  extendedForCancelling?: boolean;
}

export const isStripePaused = (
  subscription?: PausableSubscription | null,
): boolean =>
  subscription != null &&
  subscription.pause_collection !== null &&
  subscription.pause_collection !== undefined;

// Paused specifically because of the 14-day cancel-flow extension.
export const isCancelExtensionPause = (
  user: ExtendableUser | null | undefined,
  subscription?: PausableSubscription | null,
): boolean => isStripePaused(subscription) && !!user?.extendedForCancelling;

// Paused via the legacy 1-month cancel offer (manual resume, excluded from draw).
// Feature gates should use this so extension users keep full active presentation.
export const isGenuineManualPause = (
  user: ExtendableUser | null | undefined,
  subscription?: PausableSubscription | null,
): boolean => isStripePaused(subscription) && !user?.extendedForCancelling;
